
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/parlor-places/[id]/service",
      function () {
        return require("private-next-pages/parlor-places/[id]/service.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/parlor-places/[id]/service"])
      });
    }
  